let initialState = [""];

const serverData = (state = initialState, action) => {
  switch (action.type) {
    case "SDATA":
      return (state = action.payload);

    default:
      return state;
  }
};
export default serverData;
